import React from 'react';

import { IWidgetBlockComponent } from '../types/IWidgetBlock';
import { BorderedDiv, StyledTable } from './DTEP2dTable.style';
import { DTEP2dTableModel } from './types';

const DTEP2dTable: React.FC<IWidgetBlockComponent<DTEP2dTableModel>> = ({ widgetModel }) => {
    if (!widgetModel) {
        return <BorderedDiv>DateTime Table is unconfigured</BorderedDiv>;
    }

    const { fontSize, offsetLeft, displayTableHeading, timezone, columns, rows } = widgetModel;

    return (
        <StyledTable fontSize={fontSize} offsetLeft={offsetLeft}>
            {displayTableHeading && (
                <thead>
                    <tr>
                        <th colSpan={2}>{timezone}</th>
                        {columns.map((column, index) => (
                            <th key={index}>
                                <div>{column.toFormat('ccc')}</div>
                                <div>{column.toFormat('d LLL')}</div>
                            </th>
                        ))}
                    </tr>
                </thead>
            )}
            <tbody>
                {rows.map(({ label, rowValues }, index1) => (
                    <tr key={index1}>
                        <td colSpan={2}>{label}</td>
                        {rowValues.map((rowValue, index2) => (
                            <td key={index2}>{rowValue}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </StyledTable>
    );
};

export default DTEP2dTable;
